import Cookies from 'js-cookie';

export default function getGoogleCid(): string | null {
  const cidFromCookies = Cookies.get('_ga')?.slice(6);

  return cidFromCookies ? cidFromCookies : null;
}
